/*
 * Vehicle steps <-> Shrine: the only place that touches Shrine's product DOM. It never calls
 * Shrine's variant or cart code; it clicks Shrine's own option radios (VariantSelects listens to
 * 'change' on itself), writes hidden inputs tied to the product form by the form= attribute, and
 * relabels the Buy button with the same .main-atc__error / data-custom-label hooks Shrine uses.
 */
(function () {
  'use strict';
  if (window.SeatFitShrine) return;

  function slug(v) { return window.SeatFit ? window.SeatFit.slugify(v) : String(v == null ? '' : v).toLowerCase(); }

  // Option radios carry name = option name (+ an identifier suffix on some pickers), hence prefix match.
  function radios(root, name) {
    if (!root || !name) return [];
    return Array.prototype.filter.call(root.querySelectorAll('input[type="radio"]'), function (i) {
      return i.name.indexOf(name) === 0;
    });
  }

  function find(el, s) {
    var info = el.closest('product-info');
    var sid = el.getAttribute('data-section') || (info && info.getAttribute('data-section')) || '';
    var vs = document.getElementById('variant-selects-' + sid) || (info && info.querySelector('variant-selects'));
    var form = document.getElementById('product-form-' + sid);
    if (!form || form.tagName !== 'FORM') form = info && info.querySelector('form[data-type="add-to-cart-form"]');
    // form.id would return the <input name="id"> inside a product form, so read the attribute.
    var formId = form ? form.getAttribute('id') : '';
    var button = document.getElementById('ProductSubmitButton-' + sid) || (form && form.querySelector('[name="add"]'));
    // setName: the option a set step picks (seat cards: "Seat Set"; the mats' vehicle step: "Floor Mat Set").
    var setName = s.kind === 'mat' ? s.mat_set_option || 'Floor Mat Set' : s.set_option || 'Seat Set';
    // styleName: the seat product's look (Classic / Diamond ...); a product without it simply has no such radios.
    return { sid: sid, info: info, vs: vs, form: form, formId: formId, button: button, setName: setName,
      colorName: s.color_option || 'Color', sizeName: s.size_option || 'Size', styleName: s.style_option || 'Style' };
  }

  // Shrine's updateURL() replaces the whole query string with ?variant=<id> unless this is 'false';
  // the block writes variant + vehicle params itself.
  function keepUrl(shop) {
    if (shop.vs) shop.vs.dataset.updateUrl = 'false';
  }

  // Options chosen through the steps (Seat Set cards, the mats' set step, the price tier Size); the native group
  // stays in <variant-selects> (VariantSelects reads every option group) but is never shown, even if the
  // picker type is changed in the editor.
  function hideGroup(shop, name) {
    var r = radios(shop.vs, name)[0];
    var group = r && r.closest('.product-form__input');
    if (group) { group.classList.add('hidden'); group.hidden = true; }
    return !!group;
  }

  // Radio values of one option, in page order (the order the swatches show).
  function values(shop, name) {
    return radios(shop.vs, name).map(function (r) { return r.value; });
  }

  // Values a vehicle does not sell (a cover colour) go out of sight: the swatch box, or a pill's radio + label.
  // allowed = slugs to keep; null shows every value again.
  function showValues(shop, name, allowed) {
    radios(shop.vs, name).forEach(function (r) {
      var off = !!allowed && allowed.indexOf(slug(r.value)) < 0;
      var box = r.closest('.color-swatch');
      var label = !box && r.id ? document.querySelector('label[for="' + r.id.replace(/["\\]/g, '\\$&') + '"]') : null;
      [box || r, label].forEach(function (n) {
        if (n && n.classList.contains('sf-value-off') !== off) n.classList.toggle('sf-value-off', off);
      });
    });
  }

  // Loose form for hand-typed links: slugify writes '&' as 'and' (black-and-red) while Shopify handles drop it
  // (black-red), so 'and' words are ignored on both sides: black-red = black-and-red = "Black & Red".
  function loose(v) { return slug(v).split('-').filter(function (w) { return w && w !== 'and'; }).join('-'); }

  function pick(list, value) {
    var want = slug(value);
    for (var i = 0; i < list.length; i++) if (list[i].value === value) return list[i];
    for (var j = 0; j < list.length; j++) if (slug(list[j].value) === want) return list[j];
    var near = loose(value);
    for (var k = 0; near && k < list.length; k++) if (loose(list[k].value) === near) return list[k];
    return null;
  }

  // Shrine's variant change first moves <media-gallery> to the variant's picture, and media-gallery.js defines that
  // element after this block's script has run. A pick made while the page loads (every car cover picks its Size at
  // once; links that already name the set or colour) reached Shrine before the gallery existed: Shrine threw half
  // way and left the form's variant id and the price box on the first variant (live store, 2020 Camry cover:
  // $189.95 shown for the $229.95 variant, for ~15 s on a slow phone). Until the gallery is defined, picks only tick
  // their radio; one 'change' follows once it is, so Shrine renders the final combination in a single pass.
  var pendingRadio = null;
  // The gallery column sits outside <product-info>, so it is looked up by its section id, then page-wide.
  function galleryPending(shop) {
    var g = document.getElementById('MediaGallery-' + shop.sid) || document.querySelector('media-gallery');
    return !!(g && window.customElements && !customElements.get('media-gallery'));
  }
  function flushWhenGalleryReady() {
    var fire = function () {
      var r = pendingRadio;
      pendingRadio = null;
      if (r) r.dispatchEvent(new Event('change', { bubbles: true }));
    };
    // A page whose gallery script never loads must not keep the pick waiting forever.
    Promise.race([customElements.whenDefined('media-gallery'), new Promise(function (ok) { setTimeout(ok, 6000); })])
      .then(function () { setTimeout(fire, 0); });
  }

  // Returns false when the product has no such value (e.g. a set the data lists but the product lacks).
  function chooseOption(shop, name, value) {
    var r = pick(radios(shop.vs, name), value);
    if (!r) return false;
    if (r.checked) return true;
    if (galleryPending(shop)) {
      r.checked = true; // Shrine reads every checked radio when the queued 'change' arrives
      if (!pendingRadio) flushWhenGalleryReady();
      pendingRadio = r;
      return true;
    }
    r.click(); // click, not .checked = true: Shrine only reacts to the change event
    return true;
  }

  function checked(shop, name) {
    var r = radios(shop.vs, name).filter(function (i) { return i.checked; })[0];
    return r ? r.value : '';
  }

  // Variant id: VariantSelects keeps currentVariant after a change; before any change the form's
  // hidden id input holds the server-selected variant.
  function current(shop) {
    var v = shop.vs && shop.vs.currentVariant;
    var input = shop.form && shop.form.querySelector('input[name="id"]');
    return { variant: (v && v.id) || (input && input.value) || '', color: checked(shop, shop.colorName),
      style: checked(shop, shop.styleName) };
  }

  function isBuy(shop, target) {
    var b = target && target.closest ? target.closest('button, [type="submit"]') : null;
    return !!b && !!shop.button && (b === shop.button || (!!b.id && b.id === shop.button.id));
  }

  // Locked: the step prompt goes in .main-atc__error and the label is hidden (Shrine's own swap
  // for required fields; VariantSelects never touches .main-atc__error). Unlocked: data-custom-label
  // is what Shrine re-writes into the label after every variant change, so both get the final text.
  function paintButton(shop, o) {
    var b = shop.button;
    if (!b) return;
    if (o.done) b.dataset.customLabel = o.done;
    var err = b.querySelector('.main-atc__error');
    var label = b.querySelector('.main-atc__label');
    var text = b.querySelector('.main-atc__label__text') || label;
    // No aria-disabled: Shrine/Dawn CSS greys that out, while the reference step button stays solid
    // and clickable (a click scrolls to the missing step).
    b.classList.toggle('sf-atc-locked', !!o.locked);
    if (o.locked && o.text) {
      if (err && label) {
        err.textContent = o.text;
        err.style.display = '';
        label.style.display = 'none';
      } else if (text) {
        text.textContent = o.text;
      }
      return;
    }
    if (o.locked) return; // still loading: keep whatever the button says
    if (err && label) {
      err.style.display = 'none';
      err.textContent = '';
      label.style.display = '';
    }
    if (text && o.done) text.textContent = o.done;
  }

  // Hidden line-item properties. form= makes FormData(form) pick them up on the normal submit; being
  // inside #ProductInfo also covers Shrine's items[] path (bundles/upsells). No 'shrine-property-input'
  // class and no id="validator": Shrine's property selector skips those.
  function writeInputs(box, shop, props) {
    if (!box) return;
    box.textContent = '';
    if (!props || !shop.formId) return;
    Object.keys(props).forEach(function (k) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[' + k + ']';
      input.value = String(props[k]);
      input.setAttribute('form', shop.formId);
      box.appendChild(input);
    });
  }

  // True while a pick waits for the gallery: the form still holds the old variant id, so Buy must wait too.
  function pending() { return !!pendingRadio; }

  window.SeatFitShrine = {
    find: find, keepUrl: keepUrl, hideGroup: hideGroup, values: values, showValues: showValues,
    chooseOption: chooseOption, checked: checked, current: current, isBuy: isBuy, paintButton: paintButton,
    writeInputs: writeInputs, pending: pending
  };
})();
